import Swiper, { Navigation } from 'swiper';
Swiper.use([Navigation]);

/**
 * IMAGE AND CONTENT SLIDER STANDALONE MODULE
 */
export namespace ListCouncilCarousel {
    let SetupSlider = () => {
        let sliders = document.querySelectorAll('.js-council-carousel');
        let ccSliderList = [];
        /**
         * Setup each instance of the image and content slider
         */
        sliders.forEach((slider, index) => {
            let parent = slider.closest('.council-carousel__wrapper');
            let navigation = parent.querySelector('.council-carousel__navigation');
            parent.classList.add(`council-carousel__wrapper-${index}`);
            navigation.classList.add(`council-carousel__navigation-${index}`);
            slider.classList.add(`council-carousel-${index}`);

            let ccSlider = new Swiper(`.council-carousel-${index}`, {
                slidesPerView: 2,
                speed: 400,
                spaceBetween: 20,
                simulateTouch: true,

                navigation: {
                    nextEl: `.council-carousel__navigation-${index} .swiper-button-next`,
                    prevEl: `.council-carousel__navigation-${index} .swiper-button-prev`,
                },

                breakpoints: {
                    0: {
                        slidesPerView: 1,
                        spaceBetween: 20,
                    },
                    576: {
                        slidesPerView: 2,
                        spaceBetween: 20,
                    },
                    768: {
                        slidesPerView: 3,
                        spaceBetween: 30,
                    },
                    992: {
                        slidesPerView: 3,
                        spaceBetween: 50,
                    },
                },
            });

            ccSliderList.push(ccSlider);
            ccSlider.init();

            parent.classList.add('council-carousel__wrapper--initialized');
        });
    };
    export const init = () => {
        SetupSlider();
    };
}

/**
 * DOMContentLoaded may fire before script has a chance to run, so it is wise to check before adding
 */
if (document.readyState === 'loading') {
    // Loading hasn't finished yet
    document.addEventListener('DOMContentLoaded', ListCouncilCarousel.init);
} else {
    // `DOMContentLoaded` has already fired
    ListCouncilCarousel.init();
}
